import React from 'react';
import { observer } from 'mobx-react';
import ComplianceEmailsFormVM from './complaince-emails-form.viewmodel';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import Text from '../../global/text/text';
import { FormField } from '../../global/form/form-field/form-field';
import { COMPLIANCE_EMAILS_STATUS_TEXT, ALL_EMAILS_WILL_BE_BBCED, EMAIL_ADDRESSES, ENTER_COMA_SEPARATED_LIST_OF_IMAILS } from './compliance-emails.text';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';

interface IComplianceEmailsFormPresentationsProps {
    vm: ComplianceEmailsFormVM;
}

const ComplianceEmailsFormPresentations = ({
    vm
}: IComplianceEmailsFormPresentationsProps) => {
    const { intl, settingsEntity } = vm;

    return (
        <CommonPopupBodyFooterLayout
            body={
                <div className='oe-form'>
                    <div className='oe-form__body'>
                        <div className='m-top-10px m-bottom-0px flex center'>
                            <OEToggle
                                isSelected={settingsEntity.enabled}
                                onClick={settingsEntity.toggleEnabled}
                                dataTestId='compliance-emails-capture'
                            />
                            <Text
                                {...COMPLIANCE_EMAILS_STATUS_TEXT}
                                values={{
                                    suffix: settingsEntity.suffix
                                }}
                                className='line-height-25px'
                            />
                        </div>
                        {settingsEntity.enabled &&
                            <div>
                                <FormField
                                    label={intl.formatMessage(EMAIL_ADDRESSES)}
                                >
                                    <input
                                        value={vm.complianceEmails}
                                        onChange={e => vm.setComplianceEmails(e.target.value)}
                                        onBlur={() => vm.setFieldTouched()}
                                    />
                                    {
                                        vm.isFormChecked && vm.getEmailsValidationMessage() &&
                                        <span className='oe-form-field__error'>
                                            {vm.getEmailsValidationMessage()}
                                        </span>
                                    }
                                    <div className='oe-form-field__title'>{intl.formatMessage(ENTER_COMA_SEPARATED_LIST_OF_IMAILS)}</div>
                                    <div className='oe-form-field__title'>{intl.formatMessage(ALL_EMAILS_WILL_BE_BBCED)}</div>
                                </FormField>
                            </div>
                        }
                    </div>
                </div>
            }
            footer={
                <AccountAdminSettingFormFooter
                    handleClose={vm.handleClose}
                    handleSubmit={vm.handleSubmit}
                    isDisabled={vm.saving}
                />
            }
        />
    );
};

export default observer(ComplianceEmailsFormPresentations);
